/* Collection page: the jump chip for the group on screen is marked current, and kept in view in the chip row on a phone. */
(() => {
  const chips = [...document.querySelectorAll('.clc__chip')];
  if (!chips.length || !('IntersectionObserver' in window)) return;
  const row = document.querySelector('.clc__chips-in');
  const byId = new Map(chips.map(c => [c.getAttribute('href').slice(1), c]));
  const seen = new Map();
  const mark = () => {
    let best = null, top = Infinity;
    seen.forEach((r, id) => { if (r.isIntersecting && r.boundingClientRect.top < top) { top = r.boundingClientRect.top; best = id; } });
    chips.forEach(c => c.removeAttribute('aria-current'));
    const c = best && byId.get(best); if (!c) return;
    c.setAttribute('aria-current', 'true');
    if (row && row.scrollWidth > row.clientWidth) row.scrollTo({ left: c.offsetLeft - 20, behavior: 'smooth' });
  };
  const io = new IntersectionObserver(es => { es.forEach(e => seen.set(e.target.id, e)); mark(); }, { rootMargin: '-140px 0px -45% 0px' });
  byId.forEach((c, id) => { const g = document.getElementById(id); if (g) io.observe(g); });
})();
